import {Component, Input} from '@angular/core';
import { Location } from '@angular/common';
import { LanguageService } from '@shared/services/language.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['header.component.scss'],
    standalone: false
})

export class HeaderComponent {
  @Input() title = '';
  @Input() backUrl: string | null = null;
  constructor(private location: Location, public language: LanguageService, private router: Router) {}
  goBack() {
    if (this.backUrl) {
      this.router.navigateByUrl(this.backUrl);
      return;
    }
    this.location.back();
  }
}
